module.exports = __webpack_public_path__ + "static/media/DSC_0061.b2922753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0061.jpg
// module id = 624
// module chunks = 0